import React from 'react';
import { SectionCta } from '../SectionCta';
import { tools } from '../../data/sections';
export function Tools() {
  return <section className="bg-white px-4 py-16 md:px-8 md:py-24" data-id="element-318" data-mp="2mkflsrubocq7">
      <div className="mx-auto grid max-w-5xl gap-10 md:grid-cols-[1fr_1.2fr] md:gap-14" data-id="element-319" data-mp="2hji74p8iu0tg">
        <div data-id="element-320" data-mp="2dipwpsnwxpvl">
          <h2 className="font-display text-[26px] font-black leading-tight text-navy sm:text-4xl" data-id="element-321" data-mp="2dj7r0jr0lu0v">
            More Than Just Information. <span className="text-brand" data-id="element-322" data-mp="28k4u5ml6uu3z">Practical Tools You Can Use in Your Clinical Workflow.</span>
          </h2>
          <p className="mt-5 text-[16px] leading-relaxed text-ink-muted" data-id="element-323" data-mp="23rbsx8oxi3wn">
            I’ve organized this collection around resources that are easy to reference during planning and case review. Depending on the clinical question, you can consult:
          </p>
          <div className="mt-6 hidden rounded-2xl bg-navy p-6 text-white md:block" data-id="element-324" data-mp="1pt54sk9s7ia6">
            <p className="text-[15px] text-white/75" data-id="element-325" data-mp="1kt8ygedm3erg">You don’t have to work through all six volumes before using a reference.</p>
            <p className="mt-3 font-display text-lg font-extrabold leading-snug text-gold" data-id="element-326" data-mp="158oawd6pd7sf">
              Find the movement. Review the relevant considerations. Apply your professional judgment.
            </p>
          </div>
        </div>

        <ul className="divide-y divide-ice-line" data-id="element-327" data-mp="w6yjv8gqgav6">
          {tools.map(({
          icon: Icon,
          title,
          body
        }) => <li key={title} className="flex gap-4 py-5 first:pt-0" data-id="element-328" data-mp="1nzxuxge3ney9">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-brand text-white" data-id="element-329" data-mp="1o0qsbqr64s3q">
                <Icon className="h-6 w-6" aria-hidden="true" data-id="element-330" data-mp="1swo9fza9a2hk" />
              </span>
              <div data-id="element-331" data-mp="1eyzmmlwmol9v">
                <h3 className="font-display text-[17px] font-extrabold text-ink" data-id="element-332" data-mp="1jycbfc7282f3">{title}</h3>
                <p className="mt-1 text-[15px] leading-relaxed text-ink-muted" data-id="element-333" data-mp="1k06zgzdmoane">{body}</p>
              </div>
            </li>)}
        </ul>

        <div className="rounded-2xl bg-navy p-6 text-white md:hidden" data-id="element-334" data-mp="8k8hg60h2ea1">
          <p className="text-[15px] text-white/75" data-id="element-335" data-mp="2a83at290kilt">You don’t have to work through all six volumes before using a reference.</p>
          <p className="mt-3 font-display text-lg font-extrabold leading-snug text-gold" data-id="element-336" data-mp="25ab9xiqe5m5h">
            Find the movement. Review the relevant considerations. Apply your professional judgment.
          </p>
        </div>
      </div>
      <SectionCta label="Yes, I Want the Complete Roadmap" data-id="element-337" data-mp="1wgpudx6ek0v0" />
    </section>;
}